import React, { Component } from "react";

import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Input from '@material-ui/core/Input';
import TextField from '@material-ui/core/TextField';

class EditorParaula extends Component {
	constructor(props) {
		super(props);
		this.nameRef = React.createRef();
		this.handleKey = this.handleKey.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.change = this.change.bind(this);
		this.generaTextEditor = this.generaTextEditor.bind(this);
		this.printErrorDescription =this.printErrorDescription.bind(this);
		this.printErrorOptions = this.printErrorOptions.bind(this);
		this.selectReplacement = this.selectReplacement.bind(this);
		
//		this.nouSegment=1;
	}
	
//	componentDidUpdate() {
//		console.log("componentDidUpdate [EditorParaula]");
//	}
//	componentDidMount(){
//		console.log("componentDidMount [EditorParaula]");
//	}
	
	handleChange(e) {
		//console.log("handleChange: "+e.target.value);
		this.change(e.target.value);
	}
	
	selectReplacement(index){
		//console.log("selectReplacement: "+index);
		this.change(this.props.spellErrors[this.props.currentSpellError].replacements[index].value);
	}
	
	change(newValue){
		//console.log("change: "+newValue);
		
		let oldValue = this.props.segment["trg"].text.slice(this.props.spellErrors[this.props.currentSpellError].offset, this.props.spellErrors[this.props.currentSpellError].offset+this.props.spellErrors[this.props.currentSpellError].length);
		let correctedSegment = 	this.props.segment["trg"].text.slice(0, this.props.spellErrors[this.props.currentSpellError].offset) +
								newValue +
								this.props.segment["trg"].text.slice(this.props.spellErrors[this.props.currentSpellError].offset + this.props.spellErrors[this.props.currentSpellError].length);
		
		let segmentMod = this.props.segment;
		segmentMod["trg"].text = correctedSegment;
		
		let offsetChange = newValue.length - oldValue.length

		for(let i=0; i<segmentMod["trg"].tags.length; i++) {
			if(segmentMod["trg"].tags[i].position>this.props.spellErrors[this.props.currentSpellError].offset){
				segmentMod["trg"].tags[i].position+=offsetChange;
			}
		}

		let spellErrors = this.props.spellErrors;
		spellErrors[this.props.currentSpellError].length+=offsetChange;
		for(let i=this.props.currentSpellError+1; i<spellErrors.length; i++) {
			//console.log("Aplica offset a "+i+": "+offsetChange);
			spellErrors[i].offset+=offsetChange;
		}
		this.props.updateSpellError(segmentMod, spellErrors);
	}
	
	handleKey(e){
		//console.log("handleKey");
		if (e.keyCode === 9){
			e.stopPropagation();
			e.preventDefault();
			if(e.altKey){
				//console.log("Set nouSegment=1");
//				this.nouSegment=1;
				this.props.handlePrev();
			}else{
				//console.log("Set nouSegment=1");
//				this.nouSegment=1;
				this.props.handleNext();
			}
		}
	}
	
	printErrorDescription(){
		if(this.props.currentSpellError<0 || this.props.currentSpellError>=this.props.spellErrors.length){
			return "";
		}else{
			return <Box fontSize="14px">{this.props.spellErrors[this.props.currentSpellError].message}:</Box>;
		}
	}
	
	printErrorOptions(){
		if(this.props.currentSpellError<0 || this.props.currentSpellError>=this.props.spellErrors.length){
			return "";
		}else{
			let options = []
			for(let i=0; i<this.props.spellErrors[this.props.currentSpellError].replacements.length; i++){
				options.push(<span class="spell_error_alt" onClick={() => this.selectReplacement(i)}>[{this.props.spellErrors[this.props.currentSpellError].replacements[i].value}]</span>);
			}
			return <Box fontSize="14px">{options}</Box>;
		}
	}
	
	generaTextEditor(){
		let text=this.props.segment["trg"].text;
		if(this.props.showInvChars>0){
			//text=text.replace(/\s/g,"·");
			text=text.replace(/ /g,"·");
			text=text.replace(/\t/g,'\u2192');
		}
		let tempText=[];
		let inici=0;
		for(let i=0; i<this.props.spellErrors.length; i++) {
			//console.log("spell error [local index] "+i+") "+JSON.stringify(this.props.spellErrors[i]));
			tempText.push(<span>{text.slice(inici, this.props.spellErrors[i].offset)}</span>);
			let value=text.slice(this.props.spellErrors[i].offset, this.props.spellErrors[i].offset+this.props.spellErrors[i].length);
			if(i==this.props.currentSpellError){
				tempText.push(<input onKeyDown={this.handleKey} onChange={this.handleChange} class="spell_error_input" type="text" size={this.props.spellErrors[i].length+2} value={value} />);
			}else{
				tempText.push(<span class='spell_error'>{text.slice(this.props.spellErrors[i].offset, this.props.spellErrors[i].offset+this.props.spellErrors[i].length)}</span>);
			}
			inici=this.props.spellErrors[i].offset+this.props.spellErrors[i].length;
		}
		tempText.push(<span>{text.slice(inici, text.length)}</span>);
		return tempText;
	}
	
	render() {
//		console.log("props EditorParaula: ");
//		console.log(this.props);
		let text=this.generaTextEditor();
//		var fs;
//		if(this.props.segment["trg"].text.length>300){
//			fs="16px";
//		}else{
//			fs="21px";
//		}
		
		return (
			<Grid container item direction="row" justify="center" alignItems="center" xs={12} spacing={0}>
				<Grid container item direction="row" justify="flex-start" alignItems="center" xs={12} spacing={1}>
					<Grid item>
						{this.printErrorDescription()}
					</Grid>
					<Grid item>
						{this.printErrorOptions()}
					</Grid>
				</Grid>
				<Grid item xs={12}>
					<div style={{ border: "1px solid #999999", margin: "5px 0", padding: "15px 5px", backgroundColor: "#FFF"}}>
						{text}
					</div>
				</Grid>
			</Grid>
		);
	}
}

export default EditorParaula;